import React from 'react';
import { BrandIcon } from '../../ui/common/BrandIcon';

export type ProviderIconName =
  'slack' | 'jira' | 'github' | 'gmail' | 'openai-codex' | 'gemini' | 'opencode-go';

export const ProviderIcon: React.FC<{ name: ProviderIconName }> = ({ name }) => {
  const asset = name === 'openai-codex' ? '/brands/openai-blossom.svg' : '/brands/opencode-go.svg';
  const usesAsset = name === 'openai-codex' || name === 'opencode-go';
  return (
    <span
      aria-hidden="true"
      style={{
        width: 28,
        height: 28,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
      }}
    >
      {usesAsset ? (
        <img src={asset} alt="" width="24" height="24" style={{ objectFit: 'contain' }} />
      ) : (
        <BrandIcon source={name} size={24} />
      )}
    </span>
  );
};
